import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import Tooltip from '../../Tooltip'

const Ellipsis = props => {
  const containerRef = useRef()
  return (
    <div ref={containerRef} className={props.className} style={props.style}>
      {'...'}
      <Tooltip
        position={'up-left'}
        onTarget={() => containerRef.current}
        content={props.tooltip}
        showOn={'click'}
        hideOn={'click:body wheel:body scroll:body'}
        persistent={true}
      />
    </div>
  )
}

Ellipsis.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  tooltip: PropTypes.any
}

export default Ellipsis
